<template>
    <v-card class="form-container">
        <v-text-field
            v-model="newCampaign.buttonCaption"
            label="Button Text (max 30 characters): Optional field - Mandatory for Promotional Campaigns"
            maxlength="30"
            counter="30"
            class="form-field"
            required
        />
        <v-text-field
            v-model="newCampaign.buttonUrl"
            label="Button URL: Optional field - Mandatory for Promotional Campaigns"
            class="form-field"
            required
        />
        <v-text-field
            v-model="newCampaign.imageUrl"
            label="Image URL: Optional field - Mandatory for Promotional Campaigns"
            class="form-field"
            required
        />
        <div class="form-field my-2">
            <v-slider
                v-model="newCampaign.ttl"
                :min="0"
                :max="24 * 60 * 60"
                :step="30"
                :tick-size="30"
                :label="`Time To Live ( ` + hours + `:` + minutes + `:` + remainingSeconds+ ` )`"
                class="custom-slider"
                :thumb-size="100"
                :rules="[
                    v => newCampaign.ttl > 0 || 'Time To Live cannot be zero (0)'
                ]"
            >
                <template v-slot:thumb-label>
                    {{ hours }} : {{ minutes }} : {{ remainingSeconds }} Hours
                </template>
            </v-slider>
        </div>
        <v-textarea
            v-model="newCampaign.textTemplate"
            class="form-field"
            label="Viber text template, You can use up to 5 placeholder(s)"
            hint="Click on the buttons below to insert a placeholder to your SMS text, each placeholder represents column 2 and above. Column 1 is reserved for your recipient(s) list."
        />
        <div class="params-container">
            <div
                v-for="param in 5"
                :key="param"
            >
                <v-btn
                    color="cyan"
                    dark
                    @click="addParamInText(param)"
                >
                    Param {{ param }}
                </v-btn>
            </div>
        </div>

        <v-textarea
            v-if="campaign.fallback"
            v-model="newCampaign.fallbackTextTemplate"
            class="form-field"
            :label="`Viber Fallback text template, You can use up to 5 placeholder(s)`"
            hint="Click on the bellow buttons to insert a placeholder to your Viber Fallback text, each placeholder represents column 2 and above. Column 1 is reserved for your recipient(s) list."
        />
        <div v-if="campaign.fallback" class="params-container">
            <div
                v-for="param in 5"
                :key="param"
            >
                <v-btn
                    color="cyan"
                    dark
                    @click="addParamInFallbackText(param)"
                >
                    Param {{ param }}
                </v-btn>
            </div>
        </div>
        <v-btn
            color="primary"
            :loading="submitLoading"
            :disabled="submitLoading"
            @click="updateCampaign()"
        >
            Update
        </v-btn>
        <v-btn text @click="cancel()">
            Cancel
        </v-btn>
    </v-card>
</template>

<script>
    import { PRIVILEGES } from '@/utils/consts'
    export default {
        props: {
            campaign: {
                type: Object,
                default: null
            },
            submitLoading: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                newCampaign: {
                    textTemplate: '',
                    fallbackTextTemplate: '',
                    buttonUrl: '',
                    buttonCaption: '',
                    imageUrl: '',
                    ttl: 0
                }
            }
        },
        computed: {
            PRIVILEGES() {
                return PRIVILEGES
            },
            hours() {
                return Math.floor(this.newCampaign.ttl / 3600)
            },
            minutes() {
                return Math.floor((this.newCampaign.ttl % 3600) / 60)
            },
            remainingSeconds() {
                return this.newCampaign.ttl % 60
            }
        },
        watch: {
            campaign(newVal) {
                this.newCampaign = newVal
            }
        },
        methods: {
            addParamInText(param) {
                this.newCampaign.textTemplate += ` {PARAM${param}} `
            },
            addParamInFallbackText(param) {
                this.newCampaign.fallbackTextTemplate += ` {PARAM${param}} `
            },
            updateCampaign() {
                this.$emit('updateCampaign', this.newCampaign)
            },
            cancel() {
                this.$emit('cancel')
            },
            hasPrivilege(inputPrivilege) {
                const privileges = this.$store.getters.getCurrentUser?.privileges
                if (!privileges) {
                    return false
                }
                return !!privileges.find(({ privilege }) => privilege === inputPrivilege)
            }
        }
    }
</script>

<style scoped>

.params-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 15px;
    margin-bottom: 20px;
    gap: 10px;
}

.form-container {
    padding: 1rem;
}

.form-field {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

</style>
